import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ['mobileMenuContainer', 'menuBtn'];
    static values = {
        headerNodes: Array
    }

    connect()
    {
        let navElement = document.createElement('nav');
        navElement.classList.add('navigation-items', 'mobile-menu');
        this.headerNodesValue.forEach((headerNode, index) => {
            if (headerNode.children.length > 0)
            {
                let linkBlockNav = document.createElement('div');
                linkBlockNav.classList.add('link_block_navigation', 'collapsed');
                linkBlockNav.dataset.bsToggle = 'collapse';
                linkBlockNav.dataset.bsTarget = `#menuCollapse${index}`;
                linkBlockNav.innerText = headerNode.title;
                linkBlockNav.role = 'button';
                linkBlockNav.innerHTML = linkBlockNav.innerHTML + '&nbsp;&nbsp;<i class="fa-solid fa-chevron-down"></i>';
                //créer le menu collapsable pour les enfants
                let linksCollapseContainer = document.createElement('div');
                linksCollapseContainer.id = `menuCollapse${index}`;
                linksCollapseContainer.classList.add('collapse', 'collapsable-menu', 'show');
                if (headerNode.url !== '#')
                {
                    let childLink = document.createElement('a');
                    childLink.href = headerNode.url;
                    childLink.classList.add('link_block_navigation');
                    childLink.innerText = headerNode.title;
                    linksCollapseContainer.appendChild(childLink);
                }
                headerNode.children.forEach((child) => {
                    let childLink = document.createElement('a');
                    childLink.href = child.url;
                    childLink.classList.add('link_block_navigation');
                    childLink.innerText = child.title;
                    linksCollapseContainer.appendChild(childLink);
                })
                navElement.appendChild(linkBlockNav);
                navElement.appendChild(linksCollapseContainer);
            }
            else
            {
                let linkBlockNav = document.createElement('a');
                if (headerNode.id === 62)
                {
                    linkBlockNav.classList.add('partners_button', 'light-version', 'w-button', 'mt-3');
                }
                else
                {
                    linkBlockNav.classList.add('link_block_navigation');
                }
                linkBlockNav.innerText = headerNode.title;
                linkBlockNav.href = headerNode.url;
                navElement.appendChild(linkBlockNav);
            }
        })
        this.mobileMenuContainerTarget.appendChild(navElement);
        this.mobileMenuContainerTarget.querySelectorAll('.show').forEach((collapseMenu) => {
            collapseMenu.classList.remove('show');
        });

        this.menuBtnTarget.addEventListener('click', () => {
            this.toggleMenu(navElement);
        })

        document.addEventListener('click', (event) => {
            if (this.menuBtnTarget !== event.target && !this.menuBtnTarget.contains(event.target) && navElement.classList.contains('mobile-menu-show') && !navElement.contains(event.target) && event.target !== navElement) {
                this.collapseMenu(navElement);
            }
        })
    }

    toggleMenu(navElement)
    {
        navElement.classList.toggle('mobile-menu-show');
        this.mobileMenuContainerTarget.classList.toggle('is-visible');
        this.mobileMenuContainerTarget.classList.toggle('not-visible');
    }

    collapseMenu(navElement)
    {
        navElement.classList.remove('mobile-menu-show');
        this.mobileMenuContainerTarget.classList.toggle('is-visible');
        this.mobileMenuContainerTarget.classList.toggle('not-visible');
    }
}